module.exports = __webpack_public_path__ + "static/media/socialImage.a977a4a9.jpg";